import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateEstadoPericiaRequest } from '@models/estadoPericia/createEstadoPericiaRequest.model';
import { UpdateEstadoPericiaRequest } from '@models/estadoPericia/updateEstadoPericiaRequest.model';
import { CreatePlantillaEscritoRequest } from '@models/plantillaEscrito/createPlantillaEscritoRequest.model';
import { UpdatePlantillaEscritoRequest } from '@models/plantillaEscrito/updatePlantillaEscritoRequest.model';
import { PlantillaEscritoDto } from '@models/plantillaEscrito/planillaEscritoDto.model';
import { PlantillaEscritoFilter } from '@models/plantillaEscrito/plantillaEscritoFilter.model copy';

@Injectable({
  providedIn: 'root'
})
export class PlantillaEscritoService {


  private readonly baseUrl = '/api/PlantillaEscrito';

  constructor(private http: HttpClient) {}

  getAll(): Observable<PlantillaEscritoDto[]> {
    return this.http.get<PlantillaEscritoDto[]>(`${this.baseUrl}/GetAll`);
  }

  getById(id: number): Observable<PlantillaEscritoDto> {
    return this.http.get<PlantillaEscritoDto>(`${this.baseUrl}/GetById?id=${id}`);
  }

  getAllTitulos(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/GetAllTitulos`);
  }

  getAllTitulosFiltrados(searchTerm: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/GetAllTitulosFiltrados?searchTerm=${searchTerm}`);
  }

  getAllByTipoEscrito(idTipoEscrito: number): Observable<PlantillaEscritoDto[]> {
    return this.http.get<PlantillaEscritoDto[]>(`${this.baseUrl}/GetAllByTipoEscrito?idTipoEscrito=${idTipoEscrito}`);
  }

  getAllByFilter(filter: PlantillaEscritoFilter): Observable<PlantillaEscritoDto[]> {
    return this.http.post<PlantillaEscritoDto[]>(`${this.baseUrl}/GetAllPlantillaEscritoByFilter`, filter);
  }

  create(request: CreatePlantillaEscritoRequest): Observable<PlantillaEscritoDto> {
    return this.http.post<PlantillaEscritoDto>(`${this.baseUrl}/Create`, request);
  }

  update(request: UpdatePlantillaEscritoRequest): Observable<PlantillaEscritoDto> {
    return this.http.put<PlantillaEscritoDto>(`${this.baseUrl}/Update`, request);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/Delete?id=${id}`);
  }

  clone(id: number): Observable<PlantillaEscritoDto> {
    return this.http.post<PlantillaEscritoDto>(`${this.baseUrl}/Clone`, { id });
  }

}
